import { useTranslation } from "react-i18next";
import { CustomDropdown } from "../../../../../components";
import { useGetGiftPointRatio } from "../../../../../hooks/ShopCart/cart.hooks";
import { useLogout } from "../../../../../hooks/UserCenter/usercenter.hooks";

const UserIconMenu = (props: any) => {
  const { t } = useTranslation();
  const { mutate: logout } = useLogout();
  const { data: giftPointStatus } = useGetGiftPointRatio({});
  const menuItems = [
    { label: t("normal.userinfo"), key: "/usercenter?tab=userinfo" },
    { label: t("normal.orderinquiry"), key: "/usercenter?tab=orderinquiry" },
    {
      label: t("orderIquiry.giftpoint.record"),
      key: "/usercenter?tab=giftpoint",
      hide:
        giftPointStatus?.status === "0" ||
        process.env.REACT_APP_PROD_NAME_DEV === "2esim",
    },
    { label: t("normal.logout"), key: "logout" },
  ];

  return (
    <>
      <CustomDropdown
        menu={{
          items: menuItems.filter((_menu) => !_menu.hide),
          onClick: (e) => {
            if (e.key === "logout") {
              logout();
              return;
            }
            window.location.href = e.key;
          },
        }}
      >
        {props.children}
      </CustomDropdown>
    </>
  );
};

export default UserIconMenu;
